import { useTranslation } from "react-i18next"
import { GridColDef } from "@mui/x-data-grid"

import Table from "@/components/table/Table"
import Icon from "@/components/icon/Icon"
import { colors } from "@/components/colors"

export interface FilterPresetRow {
  idfPreset: number | null
  name: string
}

interface Props {
  data: FilterPresetRow[]
  selectedId: number | string | null // 새 프리셋은 name으로 식별
  onSelect: (row: FilterPresetRow) => void
  isLoading?: boolean
}

export default function FilterPresetTable({ data, selectedId, onSelect, isLoading }: Props) {
  const { t } = useTranslation()

  const getRowId = (row: FilterPresetRow) => row.idfPreset ?? row.name

  const isSelected = (row: FilterPresetRow) => getRowId(row) === selectedId

  const columns: GridColDef<FilterPresetRow>[] = [
    {
      field: "name",
      renderHeader: () => t("name"),
      flex: 1,
      minWidth: 240,
      renderCell: (params) => {
        const selected = isSelected(params.row)
        return (
          <div className="filter-preset-name-cell">
            <span className="name-text">{params.row.name}</span>
            {selected && <Icon type="arrow-right" size={16} color={colors.neutral.grey[600]} />}
          </div>
        )
      },
    },
  ]

  return (
    <Table
      className="FilterPresetTableCont"
      columns={columns}
      rows={data}
      getRowId={getRowId}
      rowHeight={52}
      loading={!!isLoading}
      disableColumnResize
      scrollbarSize={0}
      hideFooter
      rowSelectionModel={{
        type: "include",
        ids: new Set(selectedId !== null ? [selectedId] : []),
      }}
      onRowSelectionModelChange={(model) => {
        if (model.ids.size > 0) {
          const id = Array.from(model.ids)[0]
          const row = data.find((r) =>
            typeof id === "number" ? r.idfPreset === id : r.name === id,
          )
          if (row) onSelect(row)
        }
      }}
      localeText={{
        noRowsLabel: t("messages.noDataAvailable"),
      }}
      sx={{
        "& .MuiDataGrid-row:hover": {
          backgroundColor: "inherit",
          cursor: "pointer",
        },
      }}
    />
  )
}
